__turbopack_context__.v({
  "cardChips": "offer-relations-module__rHP4KG__cardChips",
  "chip": "offer-relations-module__rHP4KG__chip",
  "chipCompact": "offer-relations-module__rHP4KG__chipCompact",
  "chipIcon": "offer-relations-module__rHP4KG__chipIcon",
  "chipLabel": "offer-relations-module__rHP4KG__chipLabel",
  "chip_destination": "offer-relations-module__rHP4KG__chip_destination",
  "chip_package": "offer-relations-module__rHP4KG__chip_package",
  "chip_region": "offer-relations-module__rHP4KG__chip_region",
  "full": "offer-relations-module__rHP4KG__full",
  "fullEyebrow": "offer-relations-module__rHP4KG__fullEyebrow",
  "fullHeader": "offer-relations-module__rHP4KG__fullHeader",
  "fullTitle": "offer-relations-module__rHP4KG__fullTitle",
  "tile": "offer-relations-module__rHP4KG__tile",
  "tileArrow": "offer-relations-module__rHP4KG__tileArrow",
  "tileBody": "offer-relations-module__rHP4KG__tileBody",
  "tileIcon": "offer-relations-module__rHP4KG__tileIcon",
  "tileKind": "offer-relations-module__rHP4KG__tileKind",
  "tileName": "offer-relations-module__rHP4KG__tileName",
  "tileWrap": "offer-relations-module__rHP4KG__tileWrap",
  "tile_destination": "offer-relations-module__rHP4KG__tile_destination",
  "tile_package": "offer-relations-module__rHP4KG__tile_package",
  "tile_region": "offer-relations-module__rHP4KG__tile_region",
  "tiles": "offer-relations-module__rHP4KG__tiles",
});
